export enum ROUTE_PATH {
    LOGIN = 'login',
    OTP = 'otp',
    FORGOT_PASSWORD = 'forgot-password',
    RESET_PASSWORD = 'reset-password',
    SELECT_ROLE = 'select-role',
    HOME = 'home',
    PRODUCTION_DASHBOARD = 'production-dashboard',
    NOT_FOUND = 'notfound',
    MEMBERS = 'members',
    ADD_MEMBER = 'members/add-member',
    EDIT_MEMBER = 'members/edit-member',
    PROFILE = 'profile',
    ROLE = 'role',
    ADD_ROLE = 'role/add-role',
    EDIT_ROLE = 'role/edit-role',
    TEAM_MANAGEMENT = 'team-management',
    ADD_PROGRAM_CATALOGUE = 'program/add-program',
    EDIT_PROGRAM_CATALOGUE = 'program/edit-program',
    CONFIGURE_PROGRAM = 'configure-program',
    FUNDAMENTAL = 'fundamentals',
    KNOWLEDGE_BANK = 'knowledge-bank',
    KNOWLEDGE_GOALS = 'knowledge-goals',
    TARGET_AUDIENCE = 'target-audience',
    PRE_REQUISITES = 'pre-requisites',
    TRAINING_OBJECTIVES = 'training-objectives',
    CONTENT_DESCRIPTION = 'content-description',
    USE_CASES = 'use-cases',
    EKC_MATRIX = 'ekc-matrix',
    PROGRAM = 'program',
    COURSE = 'course',
    LESSON = 'lesson',
    EDIT_LESSON = 'edit-lesson',
    CHAPTER = 'chapter',
    SECTION = 'section',
    SECTION_TAB = 'section-tab',
    OVERVIEW = 'overview',
    EDIT = 'edit',
}
export enum PermissionType {
    Read = 'read',
    Write = 'write',
    Update = 'update',
    Delete = 'delete',
    Full = 'full',
}
export enum CommentStatus {
    Pending = 'pending',
    Approved = 'approved',
    Reject = 'rejected',
}
export interface RolePermissionList {
    ModuleId: number;
    Permission: number;
    RolePermissionId: number;
    ModuleCode: string;
    Read: boolean;
    Write: boolean;
    Update: boolean;
    Delete: boolean;
    Full: boolean;
}

export class Role {
    RoleId?: number;
    name?: string;
    RoleCode?: string;
    IsActive?: boolean;
    IsChecked?: boolean;
    description?: string;
    CreatedBy?: string;
    RolePermissionList?: RolePermissionList[];
    IsRoleInUse?: boolean;
}

export enum PRIMARY_ROLES {
    ADMIN = 1,
    OWNER = 2,
    MEMBER = 3,
    EDITOR = 4,
    REVIEWER = 5,
}

export enum EKC_TYPE {
    SUBJECT = 'subject',
    USE_CASES = 'use_cases',
}
